import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import RenumberCitationsCommand from './renumbercitationscommand';

export default class RenumberCitationsEditing extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;

    this.editor.commands.add('renumbercitations', new RenumberCitationsCommand(this.editor));
  }
}
